// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
export type DropCodeCellItem_TliFragment = { __typename?: 'TakeoffLineItem', id: string, drop?: { __typename?: 'Drop', id: string, code: string, name: string } | null | undefined, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, number: string, name: string } } };

export type DropCodeCellItem_TlivFragment = { __typename?: 'TakeoffLineItemVersion', id: string, drop?: { __typename?: 'Drop', id: string, code: string, name: string } | null | undefined, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, number: string, name: string } } };

export const DropCodeCellItem_TliFragmentDoc = gql`
    fragment DropCodeCellItem_TLI on TakeoffLineItem {
  id
  drop {
    id
    code
    name
  }
  item {
    id
    costCode {
      id
      number
      name
    }
  }
}
    `;
export const DropCodeCellItem_TlivFragmentDoc = gql`
    fragment DropCodeCellItem_TLIV on TakeoffLineItemVersion {
  id
  drop {
    id
    code
    name
  }
  item {
    id
    costCode {
      id
      number
      name
    }
  }
}
    `;